import React, { useMemo, useState } from 'react';
import styled from 'styled-components/macro';

import { getLanguage, setLanguage } from '../../config/i18n';
import { Defaults } from '../common';
import { ico } from '../controls/IconEx';
import SelectEx from '../controls/SelectEx';

const imgSize = '1.125rem';

const LangSelect = ({
  height,
  authorized = false,
  className,
}: {
  className?: string;
  height: number | string;
  authorized?: boolean;
}) => {
  const [lang, langChange] = useState(getLanguage());

  const onLangChange = (language) => {
    langChange(language);
    setLanguage(language);
  };

  return (
    <SelectEx
      id={lang}
      authorized={authorized}
      borderRadius={'8px'}
      className={className}
      resetArrowMarginLeft
      height={height}
      maxWidth={height}
      arrowType={'compact'}
      backgroundColor={Defaults.inputsBgColor}
      arrowColor={Defaults.silverGray}
      optionPaddingLeft={'0'}
      optionPaddingRight={'0'}
      fontWeight={600}
      options={[
        {
          id: 'ru',
          value: 'RU',
          // img: authorized ? undefined : ico('/ico/top/ru.svg', imgSize),
          textAlign: 'center',
          imgPosition: 'left',
          component: <LangOptionRoot>RU</LangOptionRoot>,
        },
        {
          id: 'en',
          value: 'EN',
          // img: authorized ? undefined : ico('/ico/top/en.svg', imgSize),
          textAlign: 'center',
          imgPosition: 'left',
          component: <LangOptionRoot>EN</LangOptionRoot>,
        },
      ]}
      onChange={onLangChange}
    />
  );
};

const LangOptionRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  color: ${Defaults.fontColor};

  @media (max-width: 1024px) {
    width: 40px;
  }
`;

export default LangSelect;
